import Axios from "axios";

// API
// const baseURL = "http://gep-api.test";
   
const baseURL = (process.env.VUE_APP_ENVIRONMENT == "production")?
  process.env.VUE_APP_PRODUCTION_API_URL:(process.env.VUE_APP_ENVIRONMENT == "development"?
    process.env.VUE_APP_DEVELOPMENT_API_URL:process.env.VUE_APP_LOCAL_API_URL);
    
const axios = Axios.create({
  baseURL: baseURL,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    responseType: "json",
  },
});
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (!token) {
    return config;
  }

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// CURRENCY API
const currencyURL = "https://currency.cgtechnology.io";

const axiosCurrency = Axios.create({
  baseURL: currencyURL,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    responseType: "json",
  },
});
axiosCurrency.interceptors.request.use((config) => {
  const token = process.env.VUE_APP_TOKEN_CURRENCY;

  if (!token) {
    return config;
  }

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const mockingURL = process.env.BASE_URL !== "/" ? process.env.BASE_URL : "";

const axiosMocking = Axios.create({
  baseURL: mockingURL,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    responseType: "json",
  },
});

export { axios, axiosCurrency, axiosMocking };
